import React, { useEffect, useState, useContext } from "react";
import Card from "react-bootstrap/Card";
import "./entityCardReact.css";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import EnhancedTable from "../dataSetTemplates/MultipleTemplateWith";
import SimpleTemplate from "../dataSetTemplates/SimpleTemplate";
import AlertMessage from "../shared/alertMessage";
import { LanguageContext, translateText } from "../shared/language";

function EntityCardReact({
  id,
  title,
  description,
  entity_parameters,
  queries,
  estimateDurationProps,
  queryParams,
}) {
  const [dataSetResult, setDataSetResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [durations, setDurations] = useState(null);
  const [params, setParams] = useState(entity_parameters);
  const [showAlertAtLeastOneInput, setShowAlertAtLeastOneInput] =
    useState(false);

  const { dictionary, userLanguage } = useContext(LanguageContext);
 

  const fetchEntityResults = async (paramsMemory = []) => {
    if (allParametersAreEmpty()) {
      setShowAlertAtLeastOneInput(true);
      return;
    }
    let interval;
    try {
      setShowAlertAtLeastOneInput(false);
      setDataSetResult([]);
      setError("");
      setIsLoading(true);
      const queries_ids = await startQueryExecution(paramsMemory);
      let maxTime = estimateDurationProps * 4;
      const interval = setInterval(async () => {
        try {
          if (maxTime <= 0) {
            clearInterval(interval);
            setIsLoading(false);
            setError(
              "Ha excedido el doble de tiempo de la duración estimada, por favor revise la query o modifique el tiempo estimado."
            );
          }
          const executions_overview = await getQueryStatus(queries_ids);
          setDurations(
            executions_overview.map((execution) => execution.duration)
          );
          if (allQueriesAreSucceded(executions_overview)) {
            await getQueryResults(queries_ids, interval);
          }
          maxTime = maxTime - 3;
        } catch (error) {
          clearInterval(interval);
          setIsLoading(false);
          setError(error.message);
        }
      }, 3000);
    } catch (error) {
      clearInterval(interval);
      setIsLoading(false);
      setError(error.message);
    }
  };

  const allParametersAreEmpty = () => {
    let result = true;
    for (var param of params) {
      if (param.value && param.value.length > 0) {
        result = false;
      }
    }
    return result;
  };

  const searchParamsValueIntoUrlOrDefault = () => {
    if (queryParams && queryParams.length > 0) {
      for (var param of entity_parameters) {
        const position = queryParams
          .map((queryURL) => queryURL.key)
          .indexOf(param.key);
        if (position >= 0) {
          param.value = queryParams[position].value;
          var element = document.getElementById(param.key);
          element.value = queryParams[position].value;
        }
      }
    }
    return entity_parameters;
  };

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", localStorage.getItem('token'))

  useEffect(() => {
    setShowAlertAtLeastOneInput(false);
    setDataSetResult(null);
    setError("");
    setIsLoading(false);
    setParams(entity_parameters);
    setTimeout(()=>{
      const paramsMemory = searchParamsValueIntoUrlOrDefault();
      if (queryParams && queryParams.length > 0) {
        fetchEntityResults(paramsMemory);
      } else {
        var elements = document.getElementsByTagName("input");
        for (var ii = 0; ii < elements.length; ii++) {
          if (elements[ii].type === "text") {
            elements[ii].value = "";
          }
        }
      }
    },0)
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const startQueryExecution = async (paramsMemory = []) => {
    try {
      let raw = JSON.stringify({
        entity_id: id,
        parameters: paramsMemory.length > 0 ? paramsMemory : params,
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      let response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/query`,
        requestOptions
      );
      let result = await response.json();
      if (!response.ok) {
        throw new Error(result.error.message);
      }

      return result.output;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const getQueryStatus = async (queries_ids) => {
    try {
      let raw = JSON.stringify({ queries_ids });
      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      let response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/query/status`,
        requestOptions
      );
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error.message);
      } else {
        return result.output;
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const getQueryResults = async (queries_ids, interval) => {
    try {
      let raw = JSON.stringify({ queries_ids });
      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/query/results`,
        requestOptions
      );
      const result = await response.json();
      if (!response.ok) {
        clearInterval(interval);
        setIsLoading(false);
        throw new Error(result.error.message);
      } else {
        clearInterval(interval);
        setDataSetResult(result.output);
        setIsLoading(false);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const allQueriesAreSucceded = (executions_overview) => {
    let result = true;
    for (const index in executions_overview) {
      if (executions_overview[index].status !== "SUCCEEDED") {
        result = false;
      }
    }
    return result;
  };

  const handleChangeOnParameter = (value, index) => {
    let newValue = params;
    newValue[index].value = value.trim();
    setParams(newValue);
  };

  return (
    <>
      <div style={{ marginBottom: "1rem" }}>
        <h1> {translateText(title, userLanguage)} </h1>
      </div>
      <Card
        style={{
          color: "black",
          textAlign: "left",
          marginBottom: "1rem",
        }}
        className="card__container"
      >
        <Card.Body>
          {showAlertAtLeastOneInput && (
            <AlertMessage
              title={dictionary.tituloAlertaSinRellenar}
              description={dictionary.descripcionAlertaSinRellenar}
            />
          )}

          <Card.Subtitle style={{ marginBottom: "1rem" }}>
            {translateText(description,userLanguage)}
          </Card.Subtitle>
          <div className="contenedor__parametros">
            {params.map((parameter, index) => {
              return (
                <div className="float-label" key={parameter.key}>
                  <input
                    type="text"
                    onChange={(e) =>
                      handleChangeOnParameter(e.target.value, index)
                    }
                    id={parameter.key}
                    required
                  />
                  <label
                    className={parameter.value ? "Active" : ""}
                    htmlFor={parameter.tag}
                  >
                    {translateText(parameter.tag,userLanguage)}
                  </label>
                </div>
              );
            })}
          </div>
        </Card.Body>

        <button
          className="boton"
          disabled={isLoading}
          onClick={fetchEntityResults}
        >
          {isLoading && (
            <Spinner animation="border" role="status" variant="dark" size="sm">
              <span className="sr-only">Loading...</span>
            </Spinner>
          )}
          <div className="boton-cargar__textos">{dictionary.searchButton}</div>
        </button>
      </Card>
      <section id="result-section">
        {/* {isLoading && (
          <>
            <ProgressBar
              now={estimatePercentage() || 0}
              label={`${estimatePercentage()}%`}
            />
            <p>
              <strong>Tiempo estimado:</strong> {estimateDuration} sg
            </p>
          </>
        )} */}
        {!isLoading &&
          dataSetResult !== null && 
          !error &&
          dataSetResult.map((resultado, index) => {
            if (queries[index] && queries[index].template === "multiple") {
              if(resultado.data_set.length>0){
                return (
                  <EnhancedTable
                    key={"multiple-query" + index}
                    result={resultado}
                    titleProps={queries[index].title}
                    durationProps={durations[index]}
                    navigation={queries[index].navigation}
                    columnsProps={queries[index].query_columns}
                  />
                );
              }else{
                return (
                  <AlertMessage
                            title={dictionary.tituloAlertaSinDatos}
                            description={dictionary.descripcionAlertaSinDatos}
                          />
                );
              }
            } else if (queries[index] && queries[index].template === "simple") {
              if(resultado.data_set.length>0){
                return (
                  <SimpleTemplate
                    key={"simple-query" + index}
                    result={resultado}
                    titleProps={queries[index].title}
                    durationProps={durations[index]}
                    columnsProps={queries[index].query_columns}
                  />
                );
              }else{
                return (
                  <AlertMessage
                            title={dictionary.tituloAlertaSinDatos}
                            description={dictionary.descripcionAlertaSinDatos}
                          />
                );
              }
            }
            return (
              <Alert variant={"danger"}>
                {dictionary.errorQuery}
              </Alert>
            );
          })}
        {!isLoading && error && <Alert variant={"danger"}>{error}</Alert>}
      </section>
    </>
  );
}

export default EntityCardReact;
